import React from 'react';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import BusinessIcon from '@material-ui/icons/Business';
import AssessmentIcon from '@material-ui/icons/Assessment';
import RoomIcon from '@material-ui/icons/Room';
import SettingsIcon from '@material-ui/icons/Settings';
import ChatIcon from '@material-ui/icons/Chat';
import ResourceIcon from '@material-ui/icons/EmojiObjects';
import BillingIcon from '@material-ui/icons/Payment';
import MatchingIcon from '@material-ui/icons/People';
import * as Permissions from '../../../lib/permissions';

// IMPORTANT: items with an icon will appear in the left-side Menu

const pages = {
  profile: {
    path: 'profile',
    permission: Permissions.EDIT_PROVIDER,
    icon:  <BusinessIcon />,
    label: 'Profile',
  },
  listings: {
    path: 'listings',
    permission: Permissions.EDIT_LISTINGS,
    icon:  <LocalOfferIcon />,
    label: 'Listings',
  },
  premises: {
    path: 'premises',
    permission: Permissions.EDIT_PROVIDER,
    icon:  <RoomIcon />,
    label: 'Premises',
  },
  dashboard: {
    path: 'dashboard',
    permission: Permissions.VIEW_ANALYTICS,
    icon:  <AssessmentIcon />,
    label: 'Dashboard',
  },
  reviews: {
    path: 'reviews',
    permission: Permissions.CREATE_REVIEW_RESPONSES,
    icon:  <ChatIcon />,
    label: 'Reviews',
  },
  users: {
    path: 'users',
    permission: Permissions.EDIT_USER_ROLES,
    icon:  <PeopleAltIcon />,
    label: 'Users',
  },
  billing: {
    path: 'billing',
    permission: Permissions.EDIT_BILLING,
    icon:  <BillingIcon />,
    label: 'Billing',
    divider: true,
  },
  resources: {
    path: 'resources',
    permission: null,
    icon:  <ResourceIcon />,
    label: 'Resources',
    divider: true,
  },
  settings: {
    path: 'settings',
    permission: 'Site Admin',  // use any string that isn't a real permission
    icon: <SettingsIcon />,
    label: 'Settings',
    divider: true,
  },
  matchingfees: {
    path: 'matchingfees',
    permission: 'Site Admin',  // use any string that isn't a real permission
    icon: <MatchingIcon />,
    label: 'Matching Fees',
  },
  // not in menu
  listing: {
    path: 'listing',
    permission: Permissions.EDIT_LISTINGS,
  },
  newListing: {
    path: 'newListing',
    permission: Permissions.EDIT_LISTINGS,
  },
  newPremises: {
    path: 'newPremises',
    permission: Permissions.EDIT_PROVIDER,
  },
};

export default pages;
